<section class="carousel-wrapper" [ngStyle]="carouselWrapperStyle">
  <ul class="carousel-inner" #carousel>
    <li
      *ngFor="let item of items; let i = index"
      [className]="
        i === currentSlide
          ? 'posts-carousel-item'
          : 'posts-carousel-item blurred'
      "
    >
      <ng-container [ngTemplateOutlet]="item.tpl"></ng-container>
    </li>
  </ul>
  <button
    *ngIf="currentSlide !== 0"
    (click)="prev()"
    class="btn btn-control-prev"
  >
    <mat-icon>chevron_left</mat-icon>
  </button>
  <button
    *ngIf="!(currentSlide + 1 === items.length)"
    (click)="next()"
    class="btn btn-control-next"
  >
    <mat-icon>chevron_right</mat-icon>
  </button>
</section>
